import { checkCircleSVG, errorCircleSVG } from '../../shared/helpers/icons';
export const buildCompanies = (companies) => companies.map((company => buildCompany(company)))
export const buildCompany = (company) => ({
    ...company,
    enabledIcon: company.enabled ? checkCircleSVG : errorCircleSVG,
});